import React from "react";

type ILoadingSpinnerProps = {
  color?: string;
  size?: "mini" | "small" | "middle" | "large";
};

const LoadingSpinner: React.FC<ILoadingSpinnerProps> = ({
  color = "#fff",
  size = "small",
}) => {
  // 根据 size 动态设置样式
  const sizeStyles = {
    mini: {
      container: "w-4 h-4", // 16px
      dot: "w-0.5 h-0.5", // 2px
      translate: 5, // 5px
    },
    small: {
      container: "w-5 h-5", // 20px
      dot: "w-[3px] h-[3px]", // 3px
      translate: 6, // 6px
    },
    middle: {
      container: "w-8 h-8", // 32px
      dot: "w-1 h-1", // 4px
      translate: 10, // 10px
    },
    large: {
      container: "w-12 h-12", // 48px
      dot: "w-1.5 h-1.5", // 6px
      translate: 15, // 15px
    },
  };

  const { container, dot, translate } = sizeStyles[size];

  return (
    <div className={`relative ${container} flex items-center justify-center`}>
      {[...Array(8)].map((_, index) => (
        <div
          key={index}
          className={`absolute ${dot} rounded-full animate-spin-dot`}
          style={{
            backgroundColor: color, // 动态设置颜色
            transform: `rotate(${index * 45}deg) translate(${translate}px)`,
            animationDelay: `${index * 0.15}s`,
          }}
        />
      ))}
    </div>
  );
};

export default LoadingSpinner;
